module.exports = __webpack_public_path__ + "img/rang9.1584e521.png";